<template>
  <div>
    <Modal v-model="commodityShelvesModal" :title="$t('key1002651')" width="1200" :transfer="false"
      :mask-closable="false" @on-visible-change="commodityShelvesModalChange">
      <Form class="table_box" @submit.native.prevent>
        <Table
          highlight-row
          border
          max-height="550"
          :loading="tableLoading"
          :columns="commodityShelvesColumns"
          :data="commodityShelvesData">
          <template #shelvesQuantity="{ row, index}">
            <FormItem :prop="`commodityShelvesData.${index}.shelvesQuantity`"
              :class="commodityShelvesData[index].formItemExceed ? 'ivu-form-item-error' : ''">
              <!--当数据量多的时候，v-model 实时修改shelvesQuantity 会导致性能问题出现卡顿-->
              <InputNumber :value="commodityShelvesData[index].shelvesQuantity" :max="99999999" :min="0" style="width: 150px"
                :ref="`shelvesQuantity_${index}`" @on-blur="changeValue(index)"></InputNumber>
              <div class="ivu-form-item-error-tip" v-if="commodityShelvesData[index].formItemExceed">
                <p v-if="commodityShelvesData[index].shelvesQuantity > commodityShelvesData[index].quantity">{{ $t('key1004205') }}</p>
                <p v-else-if="!commodityShelvesData[index].ymsWarehouseBlockId || !commodityShelvesData[index].ymsWarehouseLocationId">{{ $t('key1004206') }}</p>
              </div>
            </FormItem>
          </template>
        </Table>
      </Form>
      <template #footer>
        <Button class="mr15" @click="commodityShelvesModal = false">{{ $t('key1000112') }}</Button>
        <Button class="mr15" type="primary" v-if="commodityShelvesData.length >0 &&
        getPermission('ymsContainerStatus_partShelves')" @click="endListingBtn('part')">{{ $t('key1004207') }}
        </Button>
        <Button type="primary" v-if="commodityShelvesData.length >0 &&
        getPermission('ymsContainerStatus_completeShelves')" @click="endListingBtn('all')">{{ $t('key1004208') }}
        </Button>
      </template>
    </Modal>
    <!--上架异常提示弹窗-->
    <Modal v-model="shelfAbnormalPromptModal" :title="$t('key1004204')" width="900"
      :transfer="false" :mask-closable="false" @on-visible-change="shelfAbnormalPromptModalChange">
      <Alert style="margin: 0px auto 15px" type="warning" show-icon>
        {{ $t('key1004209') }}
      </Alert>
      <div class="table_box">
        <Table
          highlight-row
          border
          :span-method="handleSpan"
          max-height="550"
          :loading="tableLoading"
          :columns="abnormalColumns"
          :data="abnormalData">
        </Table>
      </div>
      <template #footer>
        <Button class="mr15" @click="resumeJobBtn">{{ $t('key1004210') }}</Button>
        <Button class="mr15" type="primary" @click="forcedEndBtn">{{ $t('key1004002') }}</Button>
      </template>
    </Modal>
  </div>
</template>

<script>
import aliasb03645cf6abd4d56a73b13687765a5d8 from '@/locale/i18nUtils.js';

import Mixin from '@/components/mixin/common_mixin';
import api from '@/api/';
import {getAllYmsWarehouseData, getYmsWarehouseBlockList, isValueEmpty, getWarehouseName} from "@/utils/common";

export default {
  name: "commodityShelvesModal",
  mixins: [Mixin],
  data() {
    let v = this;
    return {
      commodityShelvesModal: false,
      commodityShelvesColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000383'),
          minWidth: 280,
          align: 'center',
          render: (h, params) => {
            return v.tableProductInformation(h, params);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000328'),
          key: 'warehouseName',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            return h('span', getWarehouseName(v.ymsWarehouseList, params.row.ymsWarehouseId));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002329'),
          key: 'warehouseBlockName',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            return h('Select', {
              props: {
                value: v.commodityShelvesData[params.index].ymsWarehouseBlockId,
                transfer: true
              },
              on: {
                'on-change'(e) {
                  v.commodityShelvesData[params.index].ymsWarehouseBlockId = e;
                  v.commodityShelvesData[params.index].ymsWarehouseLocationId = null;
                  v.changeYmsWarehouseBlock(e, params.index);
                }
              }
            }, v.commodityShelvesData[params.index].ymsWarehouseBlockList.map(i => {
              return h('Option', {
                props: {
                  value: i.ymsWarehouseBlockId
                }
              }, i.name);
            }));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1002620'),
          key: 'warehouseLocalName',
          minWidth: 120,
          align: 'center',
          render(h, params) {
            return h('Select', {
              props: {
                value: v.commodityShelvesData[params.index].ymsWarehouseLocationId,
                transfer: true
              },
              on: {
                'on-change'(e) {
                  v.commodityShelvesData[params.index].ymsWarehouseLocationId = e;
                  if (v.commodityShelvesData[params.index].shelvesQuantity <= v.commodityShelvesData[params.index].quantity) {
                    v.commodityShelvesData[params.index].formItemExceed = false;
                  }
                }
              }
            }, v.commodityShelvesData[params.index].ymsWarehouseLocationList.map(i => {
              return h('Option', {
                props: {
                  value: i.ymsWarehouseLocationId
                }
              }, i.code);
            }));
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003962'),
          key: 'quantity',
          minWidth: 100,
          align: 'center',
          render(h, params) {
            let quantity = params.row.quantity;
            let number = '';
            if (quantity > 0) {
              number = quantity;
            } else {
              number = 0;
            }
            return h('span', number);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1003963'),
          key: 'shelvesQuantity',
          minWidth: 150,
          align: 'center',
          slot: 'shelvesQuantity'
        }
      ],
      commodityShelvesData: [],
      shelfAbnormalPromptModal: false,
      abnormalColumns: [
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000239'),
          key: 'skuInfo',
          align: 'left',
          minWidth: 320,
          render(h, params) {
            let skuImgPath = params.row._productInfo.primaryImage;
            let spuImgPath = params.row._productInfo._spuInfo.primaryImage;
            let imgPath = skuImgPath ? skuImgPath : spuImgPath;
            return h('div', {class: 'flex mt5 mb5'}, [
              v.tableImg(h, params, null, imgPath),
              h('div', {class: 'ml5'}, [
                h('div', {class: 'flex align-items-start mb5'}, [
                  h('p', {
                    style: {
                      width: '70px',
                      textAlign: 'right'
                    }
                  }, aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000100')),
                  h('p', {
                    style: {
                      flex: 1
                    }
                  }, params.row._productInfo._spuInfo.name),
                ]),
                h('div', {class: 'flex align-items-start mb5'}, [
                  h('p', {
                    style: {
                      width: '70px',
                      textAlign: 'right'
                    }
                  }, 'SKU：'),
                  h('p', {
                    style: {
                      flex: 1
                    }
                  }, params.row._productInfo.ymsSku),
                ]),
              ])
            ]);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004201'),
          key: 'originQuantity',
          align: 'center',
          minWidth: 120,
          render(h, params) {
            let quantity = params.row.originQuantity || 0;
            return h('span', quantity);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004063'),
          key: 'warehouseLocalName',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            let text = '';
            let initialState = params.row.initialState;
            if (initialState) {
              let ymsWarehouseLocationId = params.row.ymsWarehouseLocationId;
              let ymsWarehouseLocationList = params.row.ymsWarehouseLocationList;
              ymsWarehouseLocationList.map((item) => {
                if (item.ymsWarehouseLocationId === ymsWarehouseLocationId) {
                  text = item.code;
                }
              });
            } else {
              text = params.row.code;
            }
            return h('span', text);
          }
        },
        {
          title: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004056'),
          key: 'quantity',
          minWidth: 150,
          align: 'center',
          render(h, params) {
            let num = 0;
            let initialState = params.row.initialState;
            if (initialState) {
              num = params.row.shelvesQuantity || 0;
            } else {
              num = params.row.quantity;
            }
            return h('span', num);
          }
        }
      ],
      abnormalData: [],
      parameterObj: {},
      ymsWarehouseList: [],
    };
  },
  methods: {
    // 初始化接口数据
    initCommodityShelvesData(url) {
      let v = this;
      v.getCommodityShelvesDetails(url);
    },
    // 获取商品上架详情的数据
    getCommodityShelvesDetails(url) {
      let v = this;
      let ymsProductGoodsIds = [];
      getAllYmsWarehouseData().then((data) => {
        v.ymsWarehouseList = data;
        v.axios.get(url).then(response => {
          if (response.data.code === 0) {
            let data = response.data.datas;
            if (data) {
              data.map((item) => {
                item.shelvesQuantity = null;
                item.ymsWarehouseBlockId = null;
                item.ymsWarehouseLocationId = null;
                item.ymsWarehouseBlockList = [];
                item.ymsWarehouseLocationList = [];
                ymsProductGoodsIds.push(item.ymsProductGoodsId);
              });
              if (ymsProductGoodsIds.length > 0) {
                (async () => {
                  v.commodityShelvesData = await v.getProductInfoByIds(ymsProductGoodsIds, data);
                  v.changeYmsWarehouse(data[0].ymsWarehouseId, 0);
                  v.commodityShelvesModal = true;
                })();
              }
            }
          }
        });
      });
    },
    // 选中仓库，获取对应的库区数据
    changeYmsWarehouse(value, index) {
      if (value) {
        this.commodityShelvesData[index].ymsWarehouseBlockList = [];
        getYmsWarehouseBlockList(value).then((ymsWarehouseBlockList) => {
          if (this.commodityShelvesData) {
            this.commodityShelvesData.map((item, index) => {
              this.$set(this.commodityShelvesData[index], 'ymsWarehouseBlockList', ymsWarehouseBlockList);
            });
          }
        });
      }
    },
    // 选中库区，获取对应库位数据
    changeYmsWarehouseBlock(value, index) {
      if (value) {
        this.commodityShelvesData[index].ymsWarehouseLocationList = [];
        this.axios.get(api.get_ymsWarehouseLocation_queryByYmsWarehouseBlockId + `?ymsWarehouseBlockId=${value}`).then(response => {
          if (response.data.code === 0) {
            this.commodityShelvesData[index].ymsWarehouseLocationList = response.data.datas;
          }
        });
      }
    },
    // 修改上架数量
    changeValue(index) {
      let v = this;
      let targetValue = v.$refs[`shelvesQuantity_${index}`].$el.children[1].children[0].value;
      let value = targetValue === '' ? null : Number(targetValue);
      let reg = v.$regular.minPositiveInteger;
      if (value) {
        if (reg.test(value)) {
          v.$set(v.commodityShelvesData[index], 'shelvesQuantity', value);
        } else {
          v.$set(v.commodityShelvesData[index], 'shelvesQuantity', null);
          setTimeout(() => {
            v.$set(v.commodityShelvesData[index], 'shelvesQuantity', parseInt(value));
          }, 80);
        }
      }
      let formItemExceed = v.commodityShelvesData[index].formItemExceed;
      if (formItemExceed) {
        v.$set(v.commodityShelvesData[index], 'formItemExceed', false);
      }
      v.$forceUpdate();
    },
    // 部分上架、结束上架按钮
    endListingBtn(type) {
      let v = this;
      let url = '';
      let list = [];
      let talgList = [];
      let query = {};
      let partList = [];
      let groundingList = [];
      v.parameterObj = {};
      if (v.commodityShelvesData.length > 0) {
        let newData = v.handleFilterData(v.commodityShelvesData);
        v.commodityShelvesData.forEach(item => {
          if (item.shelvesQuantity > 0 && item.ymsWarehouseBlockId && item.ymsWarehouseLocationId) {
            partList.push({
              quantity: item.shelvesQuantity,
              ymsContainerGoodsCheckId: item.ymsContainerGoodsCheckId,
              ymsWarehouseBlockId: item.ymsWarehouseBlockId,
              ymsWarehouseLocationId: item.ymsWarehouseLocationId
            });
          }
          // 结束上架时需要校验待上架数量和上架数量是否一致
          if (type === 'all') {
            if (item.quantity !== item.shelvesQuantity || (item.shelvesQuantity > 0 && !item.ymsWarehouseLocationId)) {
              talgList.push(item.ymsProductGoodsId);
            }
          }
        });
        if (newData.length > 0) {
          for (let i = 0; i < newData.length; i++) {
            let item = JSON.parse(JSON.stringify(newData[i]));
            // 上架数量需小于待上架数量 填写了数量 库区库位必须填写
            item.shelvesQuantity = item.shelvesQuantity || 0;
            if ((item.shelvesQuantity > 0 && item.shelvesQuantity > item.quantity) || (item.shelvesQuantity > 0 && (!item.ymsWarehouseLocationId || !item.ymsWarehouseBlockId))) {
              groundingList.push(item.ymsProductGoodsId);
            }
            list.push({
              quantity: item.shelvesQuantity,
              ymsContainerGoodsCheckId: item.ymsContainerGoodsCheckId,
              ymsWarehouseBlockId: item.ymsWarehouseBlockId,
              ymsWarehouseLocationId: item.ymsWarehouseLocationId
            });
          }
        }
      }
      query.saveShelfYmsContainerStatusBoList = list;

      // 部分上架、结束上架需要校验上架数量不能大于待上架数量
      if (groundingList.length > 0) {
        let v = this;
        v.commodityShelvesData.map((item, index) => {
          v.$set(v.commodityShelvesData[index], 'formItemExceed', false);
          if (groundingList.includes(item.ymsProductGoodsId)) {
            v.$set(v.commodityShelvesData[index], 'formItemExceed', true);
            v.$forceUpdate();
          }
        });
        v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004202'));
        return false;
      }

      // 部分上架
      if (type === 'part') {
        url = api.post_ymsContainerStatus_partShelves;
        query.shelfType = 0; // 上架类型 0-默认 1-强制
        if (partList.length > 0) {
          query.saveShelfYmsContainerStatusBoList = partList;
          v.handerCommodityShelves(url, query);
        } else {
          v.$Message.warning(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1004203'));
          return false;
        }
      }
      // 结束上架
      else {
        if (talgList.length > 0) {
          v.shelfAbnormalPromptModal = true;
          v.parameterObj = {
            query: query,
            talgList: talgList
          };
        } else {
          url = api.post_ymsContainerStatus_completeShelves;
          query.shelfType = 0;
          v.handerCommodityShelves(url, query);
        }
      }
    },
    // 上架流程的处理
    handerCommodityShelves(url, query) {
      let v = this;
      v.axios.post(url, query, {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          v.$Message.success(aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000097'));
          v.commodityShelvesModal = false;
          v.shelfAbnormalPromptModal = false;
          v.$emit('updateData', true);
        }
      });
    },
    // 监听上架异常弹窗
    shelfAbnormalPromptModalChange(value) {
      if (value) {
        this.getShelfAbnormalPromptData();
      } else {
        this.abnormalData = [];
      }
    },
    // 监听商品上架弹窗
    commodityShelvesModalChange(value) {
      if (!value) {
        this.commodityShelvesData = [];
        this.parameterObj = {};
        this.resumeJobBtn();
      }
    },
    // 合并单元格
    handleSpan({row, column, rowIndex, columnIndex}) {
      let columnList = [0, 1];
      if (columnList.includes(columnIndex)) {
        if (row.length > 1) {
          if (rowIndex === row.currentIndex) {
            return [row.length, 1];
          } else {
            for (let i = 0; i <= row.tableLength; i++) {
              if (rowIndex === i) {
                return [0, 0];
              }
            }
          }
        }
      }
    },
    // 过滤掉没有全部填写的数据（库区、库位、上架数量）
    handleFilterData(data) {
      let newData = data.filter((item) => {
        return (!isValueEmpty(item.shelvesQuantity) || item.ymsWarehouseLocationId || item.ymsWarehouseBlockId);
      });
      return newData;
    },
    // 强制结束
    forcedEndBtn() {
      this.parameterObj.query.shelfType = 1; // 上架类型 0-默认 1-强制
      this.handerCommodityShelves(api.post_ymsContainerStatus_completeShelves, this.parameterObj.query);
    },
    // 继续作业
    resumeJobBtn() {
      let v = this;
      v.shelfAbnormalPromptModal = false;
    },
    // 获取上架异常的商品数据
    getShelfAbnormalPromptData() {
      let v = this;
      let ymsContainerGoodsCheckIds = [];
      v.commodityShelvesData.map((item) => {
        let shelvesQuantity = item.shelvesQuantity || 0;
        if (shelvesQuantity !== item.quantity || (shelvesQuantity > 0 && !item.ymsWarehouseLocationId)) {
          ymsContainerGoodsCheckIds.push(item.ymsContainerGoodsCheckId);
        }
      });
      v.axios.post(api.post_ymsContainerStatus_getShelvesQuantity, ymsContainerGoodsCheckIds,
        {loading: true, loadingText: aliasb03645cf6abd4d56a73b13687765a5d8.t('key1000247')}).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data && data.length > 0) {
            let newList = [];
            data.map((item) => {
              v.commodityShelvesData.map((ele) => {
                if (item.ymsProductGoodsId === ele.ymsProductGoodsId) {
                  if (item.list.length > 0) {
                    // 判断当前上架数量与待上架数量不一致
                    let listData = [];
                    if (ele.shelvesQuantity !== ele.quantity || !ele.ymsWarehouseLocationId) {
                      ele.quantity = ele.quantity > 0 ? ele.quantity : 0;
                      listData.push({
                        initialState: true,
                        ...ele
                      });
                    }
                    listData = [...listData, ...item.list];
                    listData.map((talg, index) => {
                      let length = listData.length;
                      talg.length = length;
                      talg.ymsContainerGoodsCheckId = item.ymsContainerGoodsCheckId;
                      talg.originQuantity = item.originQuantity;
                      if (!talg.initialState) {
                        talg.shelveQuantity = item.shelveQuantity;
                      }
                      talg.currentTalg = (length > 1 && index === 0);
                      let obj = Object.assign({}, ele, talg);
                      newList.push(obj);
                    });
                  } else {
                    ele.originQuantity = item.originQuantity;
                    ele.initialState = true;
                    newList.push(ele);
                  }
                }
              });
            });
            if (newList.length > 0) {
              newList.map((item, index) => {
                item['tableLength'] = newList.length;
                if (item.currentTalg) {
                  item['currentIndex'] = index;
                }
              });
              v.abnormalData = newList;
            }
          }
        }
      });
    },
  }
};
</script>

<style scoped>

</style>